import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../components/comman/ErrorMessage";
import { Spinner } from "reactstrap";
import BackArrowIcon from "../../components/Icons/BackArrowIcon";
import PasswordIcon from "../../components/Icons/PasswordIcon";
import EyeOpenIcon from "../../components/Icons/EyeOpenIcon";
import EyeCloseIcon from "../../components/Icons/EyeCloseIcon";
import { v4 as uuidv4 } from "uuid";
import { callApi } from "../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import { apiUrl } from "../../ApiHelper/ApiUrl";

function NewPassword() {
  const navigate = useNavigate();
  const randomDeviceId = uuidv4();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setIsLoading(true);
    let deviceId = "";
    if (localStorage.getItem("deviceId")) {
      deviceId = localStorage.getItem("deviceId");
    } else {
      deviceId = "2024_" + randomDeviceId;
    }
    localStorage.setItem("deviceId", deviceId);
    const fcmToken = localStorage.getItem("fcmToken");
    let submitData = {
      ...(location?.state?.data?.email && {
        email: location?.state?.data?.email,
      }),
      ...(location?.state?.data?.phone && {
        phone: location?.state?.data?.phone,
      }),
      password: data?.password,
      deviceId: deviceId,
      deviceToken: fcmToken ? fcmToken : randomDeviceId.slice(0, 10),
    };

    //  console.log("submitdata>>>>>>>", submitData);
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.forget_password;
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        navigate(RoutesLink?.login);
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      <div className="login-content bg-white">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-7 col-xl-8 px-0">
              <div className="login-img-card">
                <img
                  src={"/assets/img/solar-bg22.jpg"}
                  alt="login-solar"
                />
              </div>
            </div>
            <div className="col-12 col-lg-5 col-xl-4 px-0">
              <div className="d-flex align-items-center justify-content-center h-100">
                {/* login card start here... */}
                <div className="card login-card shadow-none">
                  <div className="card-body">
                    <button
                      className="btn back-arrow bg-light mb-3 p-2"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      <BackArrowIcon />
                    </button>
                    <h1 className="title">New Password</h1>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group mb-3">
                            <label htmlFor="password" className="form-label">
                              New Password
                            </label>
                            <div className="position-relative icon-input d-flex align-items-center">
                              <PasswordIcon />
                              <input
                                type={showNewPassword ? "text" : "password"}
                                name="password"
                                className="form-control"
                                id="login_password"
                                placeholder="New Password"
                                {...register("password", {
                                  required: "Please enter a valid password",
                                })}
                              />
                              <div className="password-show">
                                <div
                                  type="button"
                                  className=""
                                  onClick={togglePasswordVisibility}
                                  style={{ fontSize: "14px" }}
                                >
                                  {showNewPassword ? (
                                    <EyeOpenIcon />
                                  ) : (
                                    <EyeCloseIcon />
                                  )}
                                </div>
                              </div>
                            </div>
                            <ErrorMessage message={errors?.password?.message} />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group mb-3">
                            <label htmlFor="correctpass" className="form-label">
                              Confirm Password
                            </label>
                            <div className="position-relative icon-input d-flex align-items-center">
                              <PasswordIcon />
                              <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="password"
                                placeholder="Confirm Password"
                                className="form-control"
                                id="correctpass"
                                {...register("confirmPassword", {
                                  required: "Please confirm your password",
                                  validate: (value) =>
                                    value === watch("password") ||
                                    "Passwords do not match",
                                })}
                              />
                              <div className="password-show">
                                <div
                                  type="button"
                                  className=""
                                  onClick={toggleConfirmPasswordVisibility}
                                  style={{ fontSize: "14px" }}
                                >
                                  {showConfirmPassword ? (
                                    <EyeOpenIcon />
                                  ) : (
                                    <EyeCloseIcon />
                                  )}
                                </div>
                              </div>
                            </div>
                            <ErrorMessage
                              message={errors?.confirmPassword?.message}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-grid gap-4 btns">
                        <button
                          disabled={isLoading}
                          type="submit"
                          className="btn btn-primary w-100 fs-4 fw-bold text-white"
                        >
                          {isLoading ? <Spinner /> : "Create New Password"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                {/* login card end here... */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewPassword;
